import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
// import {
//   changeCurrentMemberMenu,
// } from "../../store/screenSlice";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Alert, TextField } from "@mui/material";
import {
  // resetEvent,
  updateEvent,
  // deleteCostInfo,
  // updateEventNoFormat,
  // addCostInfo,
  resetArrayObjects,
  clearVideoURL,
  clearMaterialURL,
} from "../../store/eventApiSlice";
// import { DevTool } from "@hookform/devtools";
import CurrencyInput from "react-currency-input-field";
// import deleteIcon from "./../../Images/Delete.png";
import {
  useForm,
  Controller,
  // useFormContext,
  // Merge,
  // FieldError,
  // FieldErrorsImpl,
} from "react-hook-form";
import { Button, PageLink } from "../StyledComp/StyledComp";
// import { DateValidationError } from "@mui/x-date-pickers";
import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
// import { all } from "axios";
// import { invalid } from "moment";
import ReactModal from "react-modal";
// import MemberServices from "../../services/MemberServices";
import EventServices from "../../services/EventServices";
import AddCostInfo from "./AddCostInfo";
// import { screenConfig } from "../../config/screenConfig";
import LinearProgress from "@mui/material/LinearProgress"; // LinearProgressProps,
import Typography from "@mui/material/Typography";
// import Box from "@mui/material/Box";
import {
  // Link,
  useNavigate,
} from "react-router-dom";
import * as routeConfig from "../../config/routes";
import { FileRejection, useDropzone } from "react-dropzone";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import CopyAllIcon from "@mui/icons-material/CopyAll";
import DeleteIcon from "@mui/icons-material/Delete";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import YesNoAlert from "../utilityComponents/YesNoAlert";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AlertWithModal from "../utilityComponents/AlertWithModal";
import { FormatUtils } from "../util/FormatUtils";

type FormValues = {
  EventName: string;
  Description: string;
  UniqueEventId: string;
  EventType: string;
  EventCategory: string;
  TestDateTime: string;
  StartDateTime: string;
  EndDateTime: string;
  EarlyBirdBy: string;
  Available: number;
  AvailableOnline: string;
  SponsorName: string;
  RegistrationLink: string;
  ZoomMeetingID: string;
  ZoomRegLink: string;
  DECredits: number;
  DEEnchEthics: number;
  PACredits: number;
  PAEthics: number;
  NJCredits: number;
  NJEthics: number;
  Comments: string;
  MaterialLink: string;
  MemberCostPerHour: number;
  NonMemberCostPerHour: number;
  MemberCost: number;
  NonMemberCost: number;
};

type FormValues1 = {
  CostName: string;
  CostNameCost: number;
};

export interface OrderDetail {
  Id: number | null;
  ParticipantType: string | null;
  FirstName: string | null;
  LastName: string | null;
  BarId: string | null;
  Location: string | null;
  Cost: string | null;
  OrderId: string | null;
  EventId: string | null;
}

// interface IConfiguration {
//   [key: string]: any;
// }

// interface Cost {
//   Id: number | null;
//   CostName: string | null;
//   Cost: number | null;
//   EventId: number | null;
// }

const CreateVideoEvent: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const form = useForm<FormValues>();
  // const formCost = useForm<FormValues1>({ mode: "onSubmit" });
  const { register, control, handleSubmit, formState, setValue } = form;
  const { errors } = formState;

  dayjs.extend(utc);
  dayjs.extend(timezone);

  // const {
  //   register: registerCost,
  //   control: controlCost,
  //   handleSubmit: handleSubmitCost,
  //   formState: { errors: errorsCost },
  //   setValue: setValueCost,
  // } = formCost;

  // const { errors: errorsCost } = formStateCost;

  const eventInfo = useSelector(
    (state: RootState) => state.eventapislice.event
  );
  // console.log("EventInfo:", eventInfo);

  // const [EventCostList, setEventCostList] = useState<Cost[] | null>(
  //   eventInfo.Costs
  // );

  // const [error, setError] = React.useState<DateValidationError | null>(null);
  const [CostModalOpen, setCostModalOpen] = useState<boolean>(false);
  // const [LocationModalOpen, setLocationModalOpen] = useState<boolean>(false);
  const [videoUploadModalOpen, setvideoUploadModalOpen] =
    useState<boolean>(false);
  const [materialUploadModalOpen, setMaterialUploadModalOpen] =
    useState<boolean>(false);
  const [YesNoAlertModalOpen, setYesNoAlertModalOpen] =
    useState<boolean>(false);
  const [YesNoMaterialAlertModalOpen, setYesNoMaterialAlertModalOpen] =
    useState<boolean>(false);

  const [showAlertModal, setShowAlertModal] = useState<boolean>(false);
  const [alertBody, setAlertBody] = useState<string>("");
  const [alertTitle, setAlertTitle] = useState<string>("");

  /* ----use config list as temporary place holder for cost name  */
  // const [costDesc, setcostDesc] = useState<IConfiguration>([]);

  // const [uniqueEventId, setUniqueEventId] = useState<string>(
  //   eventInfo.UniqueEventId ?? ""
  // );

  // const [materialLink, setMaterialLink] = useState<string>(
  //   eventInfo.MaterialLink ?? ""
  // );

  const [StartDateTime, setStartDateTime] = useState<Dayjs>(
    dayjs(eventInfo.StartDateTime) ?? dayjs(null)
  );
  const [EndDateTime, setEndDateTime] = useState<Dayjs>(
    dayjs(eventInfo.EndDateTime) ?? dayjs(null)
  );

  // const [eventType, seteventType] = useState<string>("Video");
  // const [videoURL, setvideoURL] = useState(eventInfo.VideoURL ?? null);
  const [videoUploaded, setVideoUploaded] = useState<number>(0);
  const [materialUploaded, setMaterialUploaded] = useState<number>(0);

  const [isInitialRun, setIsInitialRun] = useState<boolean>(true);

  // const memberOnlineCost = eventInfo.Costs.find(
  //   (costItem) => costItem.CostName === "Member" ?? null
  // );
  // const nonMemberOnlineCost = eventInfo.Costs.find(
  //   (costItem) => costItem.CostName === "Non-Member" ?? null
  // );

  useEffect(() => {
    if (isInitialRun === true) {
      setIsInitialRun(false);
      console.log("eventInfo useEffect called");

      dispatch(
        updateEvent({
          key: "ParentEventId",
          value: eventInfo.Id as number,
        })
      );

      dispatch(
        updateEvent({
          key: "Id",
          value: 0,
        })
      );

      dispatch(
        updateEvent({
          key: "EventType",
          value: "Video",
        })
      );

      dispatch(
        updateEvent({
          key: "EventName",
          value: "" + eventInfo.EventName,
        })
      );

      dispatch(
        updateEvent({
          key: "RegistrationLink",
          value:
            "https://www.dsba.org/event/" +
            "Video/" +
            FormatUtils.toUrlSlug(eventInfo.EventName),
        })
      );

      dispatch(
        updateEvent({
          key: "UniqueEventId",
          value: "V" + eventInfo.UniqueEventId,
        })
      );

      dispatch(
        updateEvent({
          key: "MaterialLink",
          value:
            "https:/www.dsba.org/materials/?Cleid=" +
            eventInfo.UniqueEventId?.replace(/\s/g, ""),
        })
      );

      dispatch(
        updateEvent({
          key: "VideoURL",
          value:
            "https:/www.dsba.org/video/?Cleid=" +
            eventInfo.UniqueEventId?.replace(/\s/g, ""),
        })
      );

      dispatch(
        resetArrayObjects({
          key: "Locations",
          value: "",
        })
      );

      dispatch(
        resetArrayObjects({
          key: "Costs",
          value: "",
        })
      );

      console.log(
        "date format:",
        dayjs(eventInfo.StartDateTime)?.format("YYYY-MM-DD HH:mm:ss")
      );

      eventInfo.StartDateTime &&
        setValue(
          "StartDateTime",
          dayjs(eventInfo.StartDateTime)?.format("YYYY-MM-DD HH:mm:ss"),
          {
            shouldDirty: true,
          }
        );

      dispatch(
        updateEvent({
          key: "StartDateTime",
          value: dayjs(eventInfo.StartDateTime).format("YYYY-MM-DDTHH:mm:ss"),
        })
      );

      dispatch(
        updateEvent({
          key: "EarlyBirdBy",
          value: dayjs(eventInfo.StartDateTime)
            .subtract(1, "day")
            .format("YYYY-MM-DDTHH:mm:ss"),
        })
      );

      eventInfo.StartDateTime &&
        setValue(
          "EndDateTime",
          dayjs(eventInfo.StartDateTime)
            ?.add(2, "year")
            .format("YYYY-MM-DDTHH:mm:ss"),
          {
            shouldDirty: true,
          }
        );

      dispatch(
        updateEvent({
          key: "EndDateTime",
          value: dayjs(eventInfo.StartDateTime)
            ?.add(2, "year")
            .format("YYYY-MM-DDTHH:mm:ss"),
        })
      );

      // const emptyOrderDetail: OrderDetail[] = [];
      // dispatch(
      //   updateEvent({
      //     key: "OrderDetail",
      //     value: "",
      //   })
      // );
    }
  }, []);

  const onVideoDrop = useCallback(
    (acceptedFiles: File[], fileRejections: FileRejection[]) => {
      if (fileRejections.length > 0) {
        alert("Only MP4 or WebM files are allowed!");
      } else if (acceptedFiles.length > 0) {
        const file = acceptedFiles[0];
        // uploadVideo(file);
        uploadVideoToS3(file);
      }
      console.log(acceptedFiles);
    },
    [eventInfo]
  );

  const onDocuDrop = useCallback(
    (acceptedFiles: File[], fileRejections: FileRejection[]) => {
      if (fileRejections.length > 0) {
        alert("Only pdf files are allowed!");
      } else if (acceptedFiles.length > 0) {
        uploadMaterial(acceptedFiles[0]);
      }
      console.log(acceptedFiles);
    },
    []
  );

  const {
    getRootProps: getRootPropsVideo,
    getInputProps: getInputPropsVideo,
    isDragActive: isDragActiveVideo,
  } = useDropzone({
    onDrop: onVideoDrop,
    accept: {
      "video/mp4": [".mp4"],
      "video/webm": [".webm"],
    },
  });

  const {
    getRootProps: getRootPropsDocu,
    getInputProps: getInputPropsDocu,
    isDragActive: isDragActiveDocu,
  } = useDropzone({
    onDrop: onDocuDrop,
    accept: {
      "application/pdf": [".pdf"], // Correct MIME type for PDF files
      // Add additional document types if needed
      //"application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
      //  ".docx",
      //], // Correct MIME type for Word documents
    },
  });

  const updateInput = (event: any): void => {
    console.log("key:", event.target.name, "value:", event.target.value);
    switch (event.target.name) {
      case "EventName":
        // setRegistrationLink(
        //   "http:limedia1.dsba.org/pubic/CLE/RegistrationForma/" +
        //     event.target.value.replace(/\s/g, "") +
        //     ".pdf"
        // );
        dispatch(
          updateEvent({
            key: "RegistrationLink",
            value:
              "https://www.dsba.org/event/" +
              FormatUtils.toUrlSlug(event.target.value) +
              ".pdf",
          })
        );
        break;
      case "UniqueEventId":
        // setUniqueEventId(event.target.value.replace(/\s/g, ""));
        // setMaterialLink(
        //   "https:/www.dsba.org/materials/?Cleid=" +
        //     event.target.value.replace(/\s/g, "")
        // );
        dispatch(
          updateEvent({
            key: "UniqueEventId",
            value: "v" + event.target.value,
          })
        );
        // dispatch(
        //   updateEvent({
        //     key: "MaterialLink",
        //     value:
        //       "https:/www.dsba.org/materials/?Cleid=" +
        //       event.target.value.replace(/\s/g, ""),
        //   })
        // );
        break;
      // case "EventType":
      //   seteventType(event.target.value);
      //   break;
      case "videos":
        // const formData = new FormData();
        // formData.append("media", event.target.files[0]);
        // formData.append("id", "17");
        // uploadVideo(formData);
        uploadVideoToS3(event.target.files[0]);
        break;
      case "AvailableOnline":
        dispatch(
          updateEvent({
            key: "AvailableOnline",
            value: event.target.checked ? 1 : 0,
          })
        );
        break;
      case "MemberCostPerHour":
        const memberCostPerHour =
          event.target.value === "" ? 0 : event.target.value;
        console.log("update MemberCostPerHour", memberCostPerHour);
        dispatch(
          updateEvent({
            key: "MemberCostPerHour",
            value: memberCostPerHour,
          })
        );
        break;
      case "NonMemberCostPerHour":
        const NonMemberCostPerHour =
          event.target.value === "" ? 0 : event.target.value;
        dispatch(
          updateEvent({
            key: "NonMemberCostPerHour",
            value: NonMemberCostPerHour,
          })
        );
        break;
      case "MemberCost":
        const MemberCost = event.target.value === "" ? 0 : event.target.value;
        dispatch(
          updateEvent({
            key: "MemberCost",
            value: MemberCost,
          })
        );
        break;
      case "NonMemberCost":
        const NonMemberCost =
          event.target.value === "" ? 0 : event.target.value;
        dispatch(
          updateEvent({
            key: "NonMemberCost",
            value: NonMemberCost,
          })
        );
        break;

      case "DECredits":
        const DECredits = event.target.value === "" ? 0 : event.target.value;
        dispatch(
          updateEvent({
            key: "DECredits",
            value: DECredits,
          })
        );
        break;
      case "DEEnchEthics":
        const DEEnchEthics = event.target.value === "" ? 0 : event.target.value;
        dispatch(
          updateEvent({
            key: "DEEnchEthics",
            value: DEEnchEthics,
          })
        );
        break;
      case "PACredits":
        const PACredits = event.target.value === "" ? 0 : event.target.value;
        dispatch(
          updateEvent({
            key: "PACredits",
            value: PACredits,
          })
        );
        break;

      case "PAEthics":
        const PAEthics = event.target.value === "" ? 0 : event.target.value;
        dispatch(
          updateEvent({
            key: "PAEthics",
            value: PAEthics,
          })
        );
        break;

      case "NJCredits":
        const NJCredits = event.target.value === "" ? 0 : event.target.value;
        dispatch(
          updateEvent({
            key: "NJCredits",
            value: NJCredits,
          })
        );
        break;

      case "NJEthics":
        const NJEthics = event.target.value === "" ? 0 : event.target.value;
        dispatch(
          updateEvent({
            key: "NJEthics",
            value: NJEthics,
          })
        );
        break;
      default:
        break;
    }

    dispatch(
      updateEvent({
        key: event.target.name,
        value: event.target.value,
      })
    );
  };

  const uploadVideoToS3 = async (file: File) => {
    setvideoUploadModalOpen(true);
    console.log("UniqueEventId:", eventInfo.UniqueEventId);
    // const formData = new FormData();
    // formData.append("media", file);
    // formData.append("id", "17");
    if (eventInfo.UniqueEventId) {
      const parentEventId = eventInfo.UniqueEventId.replace(/^./, "");
      console.log("uploadVideo CALLED:", parentEventId);
      const response = await EventServices.UploadVideoToS3(
        file,
        parentEventId,
        handleUploadProgress
      );
      console.log("response", response);
      const videoURL: string = response as string;
      dispatch(
        updateEvent({
          key: "VideoURL",
          value: videoURL,
        })
      );
    } else {
      alert("Parent event id missing");
      return;
    }
  };

  // const onProgressVideo = (data: any) => {
  //   // Access and handle the progress data in your component
  //   setVideoUploaded(Math.round((data.loaded / data.total) * 100));
  // };

  const handleUploadProgress = (progressPercentage: number) => {
    setVideoUploaded(progressPercentage);
  };

  // const uploadVideo = async (event: any) => {
  // const uploadVideo = async (file: File) => {
  //   setvideoUploadModalOpen(true);
  //   const formData = new FormData();
  //   formData.append("media", file);
  //   formData.append("id", "17");
  //   if (eventInfo.UniqueEventId) {
  //     const parentEventId = eventInfo.UniqueEventId.replace(/^./, "");
  //     console.log("uploadVideo CALLED:", parentEventId);
  //     const response = await EventServices.UploadVideo(
  //       formData,
  //       parentEventId,
  //       onProgressVideo
  //     );
  //     console.log("response", response);

  //     dispatch(
  //       updateEvent({
  //         key: "VideoURL",
  //         value: response?.data.data.media_url,
  //       })
  //     );
  //   } else {
  //     alert("Parent event id missing");
  //     return;
  //   }
  // };

  const onProgressMaterial = (data: any) => {
    // Access and handle the progress data in your component
    setMaterialUploaded(Math.round((data.loaded / data.total) * 100));
  };

  const uploadMaterial = async (file: File) => {
    console.log("uploadMaterial CALLED:", eventInfo);
    setMaterialUploadModalOpen(true);
    const formData = new FormData();
    formData.append("media", file);
    formData.append("id", "1");

    if (eventInfo.UniqueEventId) {
      const response = await EventServices.UploadMaterial(
        formData,
        eventInfo.UniqueEventId,
        onProgressMaterial
      );
      console.log("response", response);
      // setvideoURL(response?.data.data.media_url);

      dispatch(
        updateEvent({
          key: "MaterialLink",
          value: response?.data.data.media_url,
        })
      );
    } else {
      alert("Please enter event id");
      return;
    }
  };

  // function LinearProgressWithLabel(
  //   props: LinearProgressProps & { value: number }
  // ) {
  //   return (
  //     // <div className="input-field-div-wrapper-large">
  //     <LinearProgress color="secondary" />
  //     // </div>
  //   );
  // }

  const updateTextField = (event: any): void => {
    dispatch(
      updateEvent({
        key: event.target.name,
        value: event.target.value,
      })
    );
  };

  const updateDateField = (passedDate: Dayjs, type: string) => {
    if (dayjs(passedDate).isValid()) {
      const passedDateUTCTime = dayjs
        .tz(passedDate, "America/New_York")
        .utc()
        .format("YYYY-MM-DDTHH:mm:ss");

      dispatch(
        updateEvent({
          key: type,
          value: passedDateUTCTime,
        })
      );
    }
    switch (type) {
      case "StartDateTime":
        if (passedDate.isValid()) {
          setValue("StartDateTime", passedDate.format("YYYY-MM-DDTHH:mm:ss"), {
            shouldDirty: true,
          });
          setValue(
            "EndDateTime",
            passedDate.add(2, "years").format("YYYY-MM-DDTHH:mm:ss"),
            {
              shouldDirty: true,
            }
          );
          dispatch(
            updateEvent({
              key: "EndDateTime",
              value: passedDate.add(2, "years").format("YYYY-MM-DD HH:mm:ss"),
            })
          );
        } else {
          console.log("Start DateTime invalid");
        }
        break;
      case "EndDateTime":
        if (passedDate.isValid()) {
          setValue("EndDateTime", passedDate.format("YYYY-MM-DDTHH:mm:ss"), {
            shouldDirty: true,
          });
        } else {
          console.log("EndDateTime invalid");
        }
        break;
      default:
        console.log("default case");
        break;
    }
  };

  // const onAddCostItem = (e: any) => {
  //   console.log("onAddCostItem");
  //   console.log("onAddCostItem:", e);
  // };

  const onSubmit = async (d: any) => {
    const response = await EventServices.createEvent(eventInfo);
    console.log("response", response);
    if (response.data.data != null) {
      if (response.data.hasErrors) {
        setShowAlertModal(true);
        setAlertTitle("Database Error");
        setAlertBody(response.data.errors[0].sqlMessage);
        return;
      }
      alert("Event Created successfully");
      // dispatch(changeCurrentMemberMenu(screenConfig.eventList));
      navigate(routeConfig.EVENT_URL, { replace: false });
      // dispatch(changeCurrentMemberMenu(screenConfig.eventList));
      //  dispatch(screenChange("Events"));
    } else {
      alert(response.data.errors);
      console.log("error");
    }
  };

  const closeCostModal = (flag: boolean) => {
    console.log("isModelOpen:", CostModalOpen);
    setCostModalOpen(flag);
  };

  const cancelEvent = () => {
    // dispatch(changeCurrentMemberMenu(screenConfig.eventList));
    navigate(routeConfig.EVENT_URL, { replace: false });
  };

  const color1 = "#2d6289";

  // const muiTextFieldTheme
  const muiDatePickerColorTheme = (theme: any) =>
    createTheme({
      ...theme,
      palette: {
        primary: {
          main: color1,
        },
        secondary: {
          main: color1,
        },
        // error: {
        //   main: color1,
        // },
      },
      components: {
        MuiIconButton: {
          styleOverrides: {
            sizeMedium: {
              color1,
            },
          },
        },
        MuiOutlinedInput: {
          styleOverrides: {
            root: {
              borderRadius: 0,
            },
            notchedOutline: {
              borderWidth: 0,
              // borderBottomStyle: "solid",
              // borderBottomWidth: 1,
              boxShadow: "0px 0px 6px rgba(0, 0, 0, 0.05) inset",
            },
            input: {
              height: "0.8rem",
              background: "var(--form-input-background-color)",
              paddingTop: "20px",
              paddingBottom: "10px",
              paddingLeft: "10px",
              paddingRight: "0px",
              fontWeight: "500",
            },
          },
        },
        MuiDatePicker: {
          styleOverrides: {
            root: {
              margin: "normal",
            },
          },
        },
        MuiInputLabel: {
          styleOverrides: {
            root: {
              color: color1,
              zIndex: 1,
            },
          },
        },
        MuiFormLabel: {
          styleOverrides: {
            root: {
              fontWeight: 400,
              color: color1,
            },
          },
        },
        MuiInputBase: {
          styleOverrides: {
            root: {
              background: "var(--form-input-background-color)",
            },
          },
        },
        MuiTextField: {
          styleOverrides: {
            root: {
              // marginBottom: "1.8rem",
            },
          },
        },
      },
    });

  const handleFileUploadButtonClick = () => {
    const fileInput = document.querySelector(
      'input[type="file"]'
    ) as HTMLInputElement | null;
    if (fileInput) {
      fileInput.click();
    }
  };

  // Function to copy link to clipboard
  const copyToClipboard = (type: string) => {
    if (type === "VideoURL" && eventInfo && eventInfo.VideoURL) {
      navigator.clipboard.writeText(eventInfo.VideoURL).then(
        () => {
          toast("Link copied to clipboard!");
        },
        (err) => {
          toast("Failed to copy: ", err);
        }
      );
    }
    if (type === "MaterialLink" && eventInfo && eventInfo.MaterialLink) {
      navigator.clipboard.writeText(eventInfo.MaterialLink).then(
        () => {
          toast("Link copied to clipboard!");
        },
        (err) => {
          toast("Failed to copy: ", err);
        }
      );
    }
  };

  const deleteVideoURL = (YesorNo: boolean) => {
    console.log("deleteVideoURL called:", YesorNo);
    if (YesorNo) {
      dispatch(clearVideoURL());
      // alert("Uploaded video Deleted Succefully");
      toast("Uploaded video Deleted Succefully");
    }
    setYesNoAlertModalOpen(false);
  };

  const deleteMaterialURL = (YesorNo: boolean) => {
    console.log("deleteMaterialURL called:", YesorNo);
    if (YesorNo) {
      dispatch(clearMaterialURL());
      toast("Uploaded Material Deleted Succefully");
    }
    setYesNoMaterialAlertModalOpen(false);
  };

  return (
    <div className="dashboard-content-wrapper" style={{ marginBottom: "20px" }}>
      <ToastContainer />
      <div className="horizontal-wrapper-spacebetween">
        <h1 className="page-heading">Create Video Event</h1>
        <div
          style={{ cursor: "pointer", paddingRight: "0rem", color: "blue" }}
          onClick={cancelEvent}
        >
          <PageLink>Cancel </PageLink>
        </div>
      </div>
      <form
        key={1}
        className="form-wrapper"
        onSubmit={handleSubmit(onSubmit)}
        noValidate
      >
        {/* ----------Event Information------------ */}
        <div className="section-box">
          <h3 className="section-heading">Event Information</h3>
          <div className="horizontal-wrapper-spacebetween">
            <div className="input-field-div-wrapper-large">
              <input
                className="input-field-div-small"
                placeholder=""
                id="EventName"
                {...register("EventName", {
                  required: "* required field",
                })}
                autoComplete="off"
                readOnly={true}
                onChange={(e) => {
                  updateInput(e);
                }}
                value={eventInfo.EventName ?? ""}
              />
              <label className="form-label" htmlFor="EventName">
                Event Name (Read only)
              </label>
              <p
                className="form-error"
                style={{ position: "absolute", top: "100%", marginTop: "0" }}
              >
                {errors.EventName?.message}
              </p>
            </div>
            <div className="input-field-div-wrapper">
              <input
                className="input-field-div-small"
                placeholder=""
                id="UniqueEventId"
                {...register("UniqueEventId", {
                  required: "* required field",
                })}
                value={eventInfo.UniqueEventId ?? ""}
                autoComplete="off"
                readOnly={true}
                onChange={(e) => {
                  updateInput(e);
                }}
              />
              <label className="form-label" htmlFor="UniqueEventId">
                Event ID (Read only)
              </label>
              <p
                className="form-error"
                style={{ position: "absolute", top: "100%", marginTop: "0" }}
              >
                {errors.UniqueEventId?.message}
              </p>
            </div>
            <div className="input-field-div-wrapper-smallnominwidth">
              <select
                className="dropdown-control-large-insidetextfield"
                id="EventType"
                // placeholder=""
                style={{ color: "#25284e" }}
              >
                <option value="Video">Video</option>
              </select>
              <p
                className="form-error"
                style={{ position: "absolute", top: "100%", marginTop: "0" }}
              >
                {errors.EventType?.message}
              </p>
            </div>
          </div>
          <div className="horizontal-wrapper-spacebetween">
            <div className="input-field-div-wrapper">
              <Controller
                control={control}
                name="StartDateTime"
                rules={{ required: "* required field" }}
                render={({
                  field: { onChange, onBlur, value, name, ref },
                  fieldState: { error },
                }) => (
                  <ThemeProvider theme={muiDatePickerColorTheme}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DateTimePicker
                        className="datepicker-local"
                        label="Start Date"
                        value={dayjs(eventInfo.StartDateTime) ?? dayjs(value)}
                        slotProps={{
                          textField: {
                            error: Boolean(error),
                            helperText: error
                              ? errors.StartDateTime?.message?.toString()
                              : "",
                          },
                        }}
                        onChange={(date: any) => {
                          date && setStartDateTime(date);
                          updateDateField(date, "StartDateTime");
                        }}
                      />
                    </LocalizationProvider>
                  </ThemeProvider>
                )}
              />
            </div>

            <div className="input-field-div-wrapper">
              <Controller
                control={control}
                name="EndDateTime"
                rules={{ required: "* required field" }}
                render={({
                  field: { onChange, onBlur, value, name, ref },
                  fieldState: { error },
                }) => (
                  <ThemeProvider theme={muiDatePickerColorTheme}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DateTimePicker
                        className="datepicker-local"
                        label="End Date"
                        value={dayjs(eventInfo.EndDateTime) ?? dayjs(value)}
                        slotProps={{
                          textField: {
                            error: Boolean(error),
                            helperText: error
                              ? errors.EndDateTime?.message?.toString()
                              : "",
                          },
                        }}
                        onChange={(date: any) => {
                          date && setEndDateTime(date);
                          updateDateField(date, "EndDateTime");
                        }}
                      />
                    </LocalizationProvider>
                  </ThemeProvider>
                )}
              />
            </div>
            <div className="input-field-div-wrapper">
              <input
                className="input-field-div-small"
                placeholder=""
                id="SponsorName"
                name="SponsorName"
                autoComplete="off"
                onChange={(e) => {
                  updateInput(e);
                }}
                value={eventInfo.SponsorName ?? ""}
              />
              <label className="form-label" htmlFor="SponsorName">
                Sponsor
              </label>
            </div>
          </div>
          <div className="textarea-wrapper" style={{ width: "100%" }}>
            <TextField
              className="textarea"
              id="Description"
              name="Description"
              placeholder="Event Description"
              multiline
              rows={3}
              onChange={(e) => {
                updateTextField(e);
              }}
              value={eventInfo.Description}
            />
          </div>
          {/* <div className="horizontal-wrapper-spacebetween">
            {
              // eventType === "Video" &&
              eventInfo.VideoURL === null ? (
                <>
                  <div
                    className="input-field-div-wrapper-large"
                    style={{
                      border: "2px",
                      borderStyle: "dashed",
                      borderColor: "#cccccc",
                      borderRadius: "4px",
                      background: "none",
                      height: "auto",
                    }}
                  >
                    <div
                      {...getRootPropsVideo({
                        onClick: (event) => {
                          event.stopPropagation();
                          event.preventDefault();
                        },
                      })}
                      className={`dropzone ${
                        isDragActiveVideo ? "active" : ""
                      }`}
                    >
                      <input {...getInputPropsVideo()} />
                      {isDragActiveVideo ? (
                        <>
                          <p>Drop the Video files here ...</p>
                          <small>use only .MP4 or .WebM</small>
                        </>
                      ) : (
                        <>
                          <p>
                            Drag 'n' drop some files here, or click "Add Video
                            File button"
                          </p>
                          <small>Only MP4 or WebM files are allowed</small>
                        </>
                      )}
                      <button
                        type="button"
                        className="button"
                        onClick={handleFileUploadButtonClick}
                      >
                        Add Video File
                      </button>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div
                    className="form-wrapper-vertical"
                    style={{
                      height: "auto",
                      width: "45%",
                    }}
                  >
                    <div
                      className="textarea-wrapper"
                      style={{ width: "100%", marginBottom: "0.5rem" }}
                    >
                      <TextField
                        className="textarea"
                        placeholder=""
                        id="videoURL"
                        name="videoURL"
                        autoComplete="off"
                        // readOnly={true}
                        disabled={true}
                        multiline
                        rows={2}
                        value={eventInfo.VideoURL ?? ""}
                      />
                      <label
                        className="form-label"
                        htmlFor="VideoURL"
                        style={{
                          fontSize: "0.8rem",
                          fontWeight: "400",
                          top: "-0.5rem",
                          left: "0.5rem",
                          backgroundColor: "rgba(255, 255, 255, 100)",
                        }}
                      >
                        Video Link
                      </label>
                    </div>

                    <div className="horizontal-wrapper-rightaligned">
                      <div
                        style={{
                          width: "auto",
                          height: "2rem",
                        }}
                      >
                        <a href={eventInfo.VideoURL as string} target="_blank">
                          <PlayCircleOutlineIcon />
                          Play
                        </a>
                      </div>
                      <div
                        style={{
                          width: "auto",
                          height: "2rem",
                          display: "flex",
                          alignItems: "left",
                          cursor: "pointer",
                          color: "#1976d2",
                          paddingLeft: ".8rem",
                        }}
                        onClick={(string) => copyToClipboard("VideoURL")}
                      >
                        <a>
                          <CopyAllIcon />
                          Copy
                        </a>
                      </div>
                      <div
                        style={{
                          width: "auto",
                          height: "2rem",
                          color: "#1976d2",
                          paddingLeft: ".8rem",
                          cursor: "pointer",
                        }}
                        onClick={() => setYesNoAlertModalOpen(true)}
                      >
                        <a>
                          <DeleteIcon />
                          Delete
                        </a>
                      </div>
                    </div>
                  </div>
                </>
              )
            }
            {eventInfo.MaterialLink === null ? (
              <>
                <div
                  className="input-field-div-wrapper-large"
                  style={{
                    border: "2px",
                    borderStyle: "dashed",
                    borderColor: "#cccccc",
                    borderRadius: "4px",
                    background: "none",
                    height: "auto",
                  }}
                >
                  <div
                    {...getRootPropsDocu({
                      onClick: (event) => {
                        event.stopPropagation();
                        event.preventDefault();
                      },
                    })}
                    className={`dropzone ${isDragActiveDocu ? "active" : ""}`}
                  >
                    <input {...getInputPropsDocu()} />
                    {isDragActiveDocu ? (
                      <>
                        <p>Drop the Material here ...</p>
                        <small>use only .pdf</small>
                      </>
                    ) : (
                      <>
                        <p>
                          Drag 'n' drop files here, or click "Add Material File
                          button"
                        </p>
                        <small>use only .pdf</small>
                      </>
                    )}
                    <button
                      type="button"
                      className="button"
                      onClick={handleFileUploadButtonClick}
                    >
                      Add Material File
                    </button>
                  </div>
                </div>
              </>
            ) : (
              <div
                className="form-wrapper-vertical"
                style={{
                  height: "auto",
                  width: "45%",
                }}
              >
                <div
                  className="textarea-wrapper"
                  style={{ width: "100%", marginBottom: "0.5rem" }}
                >
                  <TextField
                    className="textarea"
                    placeholder=""
                    id="MaterialLink"
                    name="MaterialLink"
                    autoComplete="off"
                    // readOnly={true}
                    disabled={true}
                    multiline
                    rows={2}
                    value={eventInfo.MaterialLink ?? ""}
                  />
                  <label
                    className="form-label"
                    htmlFor="MaterialLink"
                    style={{
                      fontSize: "0.8rem",
                      fontWeight: "400",
                      top: "-0.5rem",
                      left: "0.5rem",
                      backgroundColor: "rgba(255, 255, 255, 100)",
                    }}
                  >
                    Material Link
                  </label>
                </div>
                <div className="horizontal-wrapper-rightaligned">
                  <div
                    style={{
                      width: "auto",
                      height: "2rem",
                      // backgroundColor: "green",
                    }}
                  >
                    <a href={eventInfo.MaterialLink as string} target="_blank">
                      <OpenInNewIcon />
                      View
                    </a>
                  </div>
                  <div
                    style={{
                      width: "auto",
                      height: "2rem",
                      display: "flex",
                      alignItems: "left",
                      cursor: "pointer",
                      color: "#1976d2",
                      paddingLeft: ".8rem",
                    }}
                    onClick={(string) => copyToClipboard("MaterialLink")}
                  >
                    <a>
                      <CopyAllIcon />
                      Copy
                    </a>
                  </div>
                  <div
                    style={{
                      width: "auto",
                      height: "2rem",
                      color: "#1976d2",
                      paddingLeft: ".8rem",
                      cursor: "pointer",
                    }}
                    onClick={() => setYesNoMaterialAlertModalOpen(true)}
                  >
                    <a>
                      <DeleteIcon />
                      Delete
                    </a>
                  </div>
                </div>
              </div>
            )}
          </div> */}

          <div className="horizontal-wrapper-spacebetween">
            <div
              className="input-field-div-wrapper"
              style={{ marginTop: "1rem", width: "45%" }}
            >
              <input
                className="input-field-div-small"
                placeholder=""
                id="videoURL"
                name="videoURL"
                autoComplete="off"
                disabled={true}
                value={eventInfo.VideoURL ?? ""}
              />
              <label className="form-label" htmlFor="SponsorName">
                Video Link (read only)
              </label>
            </div>
            <div
              className="input-field-div-wrapper"
              style={{ marginTop: "1rem", width: "45%" }}
            >
              <input
                className="input-field-div-small"
                placeholder=""
                id="MaterialLink"
                name="MaterialLink"
                autoComplete="off"
                disabled={true}
                value={eventInfo.MaterialLink ?? ""}
              />
              <label className="form-label" htmlFor="SponsorName">
                Material Link (read only)
              </label>
            </div>
          </div>

          <div className="horizontal-wrapper-spacebetween">
            <div
              className="input-field-div-wrapper"
              style={{ marginTop: "1rem", width: "45%" }}
            >
              <input
                className="input-field-div-small"
                placeholder=""
                id="RegistrationLink"
                name="RegistrationLink"
                autoComplete="off"
                disabled={true}
                value={eventInfo.RegistrationLink ?? ""}
              />
              <label className="form-label" htmlFor="SponsorName">
                Registration Link (read only)
              </label>
            </div>
          </div>

          {/* <div className="horizontal-wrapper-spacebetween"> */}
          {/* <div className="input-field-div-wrapper-largest"> */}
          {/* <div
              className="form-wrapper-vertical"
              style={{
                height: "auto",
                width: "45%",
              }}
            >
              <div
                className="textarea-wrapper"
                style={{ width: "100%", marginBottom: "0.5rem" }}
              >
                <TextField
                  className="input-field-div-small"
                  placeholder=""
                  id="RegistrationLink"
                  name="RegistrationLink"
                  // {...register("RegistrationLink", {
                  //   required: "* required field",
                  // })}
                  autoComplete="off"
                  // readOnly={true}
                  disabled={true}
                  value={eventInfo.RegistrationLink ?? ""}
                  // onChange={(e) => {
                  //   updateInput(e);
                  // }}
                />
                <label className="form-label" htmlFor="RegistrationLink">
                  Registration Link
                </label> */}
          {/* <p
                className="form-error"
                style={{ position: "absolute", top: "100%", marginTop: "0" }}
              >
                {errors.RegistrationLink?.message}
              </p> */}
          {/* </div>
            </div>
          </div> */}
          {/* ----------Cost Information------------ */}

          <h3 className="section-heading">Cost Information</h3>

          <div className="horizontal-wrapper-spacebetween">
            <div className="input-field-div-wrapper-smallnominwidth">
              <CurrencyInput
                className="input-field-div-small"
                id="MemberCostPerHour"
                // placeholder=""
                value={eventInfo.MemberCostPerHour ?? 60}
                // defaultValue={0}
                {...register("MemberCostPerHour")}
                decimalsLimit={2}
                pattern="[0-9]*"
                onChange={(e) => {
                  updateInput(e);
                }}
                // onValueChange={(value, name) => console.log(value, name)}
              />
              <label className="form-label" htmlFor="MemberCostPerHour">
                Member Cost / Hour
              </label>
            </div>

            <div className="input-field-div-wrapper-smallnominwidth">
              <CurrencyInput
                className="input-field-div-small"
                id="NonMemberCostPerHour"
                // placeholder=""
                pattern="[0-9]*"
                value={eventInfo.NonMemberCostPerHour ?? 120}
                // defaultValue={0}
                {...register("NonMemberCostPerHour")}
                decimalsLimit={2}
                onChange={(e) => {
                  updateInput(e);
                }}
                // onValueChange={(value, name) => console.log(value, name)}
              />
              <label className="form-label" htmlFor="NonMemberCostPerHour">
                Non Member Cost / Hour
              </label>
            </div>

            <div className="input-field-div-wrapper-smallnominwidth">
              <CurrencyInput
                className="input-field-div-small"
                id="MemberCost"
                placeholder=""
                value={eventInfo.MemberCost ?? 0}
                // defaultValue={0}
                {...register("MemberCost")}
                decimalsLimit={2}
                onChange={(e) => {
                  updateInput(e);
                }}
                // onValueChange={(value, name) => console.log(value, name)}
              />
              <label className="form-label" htmlFor="MemberCost">
                Member Cost Online
              </label>
            </div>

            <div className="input-field-div-wrapper-smallnominwidth">
              <CurrencyInput
                className="input-field-div-small"
                id="NonMemberCost"
                placeholder=""
                value={eventInfo.NonMemberCost ?? 0}
                // defaultValue={0}
                {...register("NonMemberCost")}
                decimalsLimit={2}
                onChange={(e) => {
                  updateInput(e);
                }}
                // onValueChange={(value, name) => console.log(value, name)}
              />
              <label className="form-label" htmlFor="NonMemberCost">
                Non Member Cost Online
              </label>
            </div>
          </div>

          {/* ----------Credit Information------------ */}

          <h3 className="section-heading">Credit Information</h3>
          <div className="horizontal-wrapper-spacebetween">
            <div className="input-field-div-wrapper-smallnominwidth">
              <input
                className="input-field-div-small"
                type="number"
                placeholder=""
                id="DECredits"
                name="DECredits"
                autoComplete="off"
                onChange={(e) => {
                  updateInput(e);
                }}
                value={eventInfo.DECredits ?? 0}
              />
              <label className="form-label" htmlFor="DECredits">
                DE Credits
              </label>
            </div>
            <div className="input-field-div-wrapper-smallnominwidth">
              <input
                className="input-field-div-small"
                type="number"
                placeholder=""
                id="DEEnchEthics"
                name="DEEnchEthics"
                autoComplete="off"
                onChange={(e) => {
                  updateInput(e);
                }}
                value={eventInfo.DEEnchEthics ?? 0}
              />
              <label className="form-label" htmlFor="DEEnchEthics">
                DE Ethics
              </label>
            </div>
            <div className="input-field-div-wrapper-smallnominwidth">
              <input
                className="input-field-div-small"
                type="number"
                placeholder=""
                id="PACredits"
                name="PACredits"
                autoComplete="off"
                onChange={(e) => {
                  updateInput(e);
                }}
                value={eventInfo.PACredits ?? 0}
              />
              <label className="form-label" htmlFor="PACredits">
                PA Credits
              </label>
            </div>
            <div className="input-field-div-wrapper-smallnominwidth">
              <input
                className="input-field-div-small"
                type="number"
                placeholder=""
                id="PAEthics"
                name="PAEthics"
                autoComplete="off"
                onChange={(e) => {
                  updateInput(e);
                }}
                value={eventInfo.PAEthics ?? 0}
              />
              <label className="form-label" htmlFor="PAEthics">
                PA Ethics
              </label>
            </div>
          </div>
          <div className="horizontal-wrapper-spacebetween">
            <div className="input-field-div-wrapper-smallnominwidth">
              <input
                className="input-field-div-small"
                type="number"
                placeholder=""
                id="NJCredits"
                name="NJCredits"
                autoComplete="off"
                onChange={(e) => {
                  updateInput(e);
                }}
                value={eventInfo.NJCredits ?? 0}
              />
              <label className="form-label" htmlFor="NJCredits">
                NJ Credits
              </label>
            </div>
            <div className="input-field-div-wrapper-smallnominwidth">
              <input
                className="input-field-div-small"
                type="number"
                placeholder=""
                id="NJEthics"
                name="NJEthics"
                autoComplete="off"
                onChange={(e) => {
                  updateInput(e);
                }}
                value={eventInfo.NJEthics ?? 0}
              />
              <label className="form-label" htmlFor="NJEthics">
                NJ Ethics
              </label>
            </div>
          </div>
        </div>

        {/* ----------Availability Settings------------ */}
        <div className="section-box">
          <h3 className="section-heading">Availability Settings</h3>
          <div className="horizontal-wrapper-spacebetween">
            <div className="form-group">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="AvailableOnline"
                  name="AvailableOnline"
                  checked={eventInfo.AvailableOnline === 1}
                  onChange={(e) => updateInput(e)}
                />
                <label
                  className="form-check-label"
                  htmlFor="AvailableOnline"
                >
                  Available online (can be purchased on website)
                </label>
              </div>
            </div>
          </div>
        </div>

        {/* ----------Submit button Information------------ */}
        <div className="submit-floating-button-div">
          <Button
            className="submit-button-div"
            type="submit"
            disabled={
              // eventType === "Video" &&
              eventInfo.VideoURL === null ? true : false
            }
          >
            Create Event
          </Button>
        </div>
      </form>
      {/* cost modal */}
      <ReactModal
        isOpen={CostModalOpen}
        // onRequestClose={() => setCostModalOpen(false)}
        className="editinfo-modal-large"
        overlayClassName="overlay"
      >
        <div
          className="horizontal-wrapper-spacebetween"
          style={{ marginBottom: "2rem", zIndex: "20", height: "5%" }}
        >
          <h1
            className="page-heading"
            // style={{ marginBottom: "2rem", }}
          >
            Add Cost Information
          </h1>
          <PageLink
            onClick={() => setCostModalOpen(false)}
            style={{ marginBottom: "2rem" }}
          >
            Cancel
          </PageLink>
        </div>
        <AddCostInfo closeCostModal={closeCostModal} />
      </ReactModal>

      {/* Video Upload progress */}
      <ReactModal
        isOpen={videoUploadModalOpen}
        className="saveSearchModal"
        overlayClassName="overlay"
      >
        <div
          className="horizontal-wrapper-spacebetween"
          style={{ marginBottom: "2rem", zIndex: "20", height: "5%" }}
        >
          <h1
            className="page-heading"
            // style={{ marginBottom: "2rem", }}
          >
            {eventInfo.VideoURL === null
              ? "Video Upload Inprogress"
              : "Upload Complete"}
          </h1>
        </div>
        <div className="uploadPercent" style={{ width: "10%", height: "100%" }}>
          <Typography variant="h3" color="secondary">
            {videoUploaded}%
          </Typography>
        </div>
        <div
          className="uploadProgress"
          style={{ width: "90%", height: "100%" }}
        >
          <LinearProgress
            variant="determinate"
            color="secondary"
            value={videoUploaded}
          />
        </div>

        <div className="button-wrapper" style={{ marginTop: "1rem" }}>
          <div className="submit-button-div">
            <Button
              type="submit"
              disabled={eventInfo.VideoURL === null ? true : false}
              onClick={() => setvideoUploadModalOpen(false)}
            >
              Close
            </Button>
          </div>
        </div>
      </ReactModal>

      <ReactModal
        isOpen={materialUploadModalOpen}
        className="saveSearchModal"
        overlayClassName="overlay"
      >
        <div
          className="horizontal-wrapper-spacebetween"
          style={{ marginBottom: "2rem", zIndex: "20", height: "5%" }}
        >
          <h1
            className="page-heading"
            // style={{ marginBottom: "2rem", }}
          >
            {eventInfo.MaterialLink === null
              ? "Video Upload Inprogress"
              : "Upload Complete"}
          </h1>
        </div>
        <div className="uploadPercent" style={{ width: "10%", height: "100%" }}>
          <Typography variant="h3" color="secondary">
            {materialUploaded}%
          </Typography>
        </div>
        <div
          className="uploadProgress"
          style={{ width: "90%", height: "100%" }}
        >
          <LinearProgress
            variant="determinate"
            color="secondary"
            value={materialUploaded}
          />
        </div>

        <div className="button-wrapper" style={{ marginTop: "1rem" }}>
          <div className="submit-button-div">
            <Button
              type="submit"
              disabled={eventInfo.MaterialLink === null ? true : false}
              onClick={() => setMaterialUploadModalOpen(false)}
            >
              Close
            </Button>
          </div>
        </div>
      </ReactModal>

      {/* yes no Alert */}
      <ReactModal
        isOpen={YesNoAlertModalOpen}
        className="saveSearchModal"
        overlayClassName="overlay"
      >
        <YesNoAlert callBack={deleteVideoURL} />
      </ReactModal>

      {/* yes no Material Alert */}
      <ReactModal
        isOpen={YesNoMaterialAlertModalOpen}
        className="saveSearchModal"
        overlayClassName="overlay"
      >
        <YesNoAlert callBack={deleteMaterialURL} />
      </ReactModal>
      {showAlertModal ? (
        <AlertWithModal
          title={alertTitle}
          body={alertBody}
          show={showAlertModal}
          onClose={() => setShowAlertModal(false)} // Close the modal
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default CreateVideoEvent;
